import { Component, Input, OnInit } from '@angular/core';
import { InputDropdownOption } from './input-dropdown-option.interface';
import { BaseInputComponent } from '../forms/base-input/base-input.component';
import { UI_CONSTANTS } from '@edassist/shared';
import { SortUtilityService } from '@edassist/common';

@Component({
	selector: 'ea-ui-input-dropdown',
	templateUrl: './input-dropdown.component.html',
	styleUrls: ['../forms/base-input/base-input.component.scss', './input-dropdown.component.scss']
})
export class InputDropdownComponent extends BaseInputComponent implements OnInit {
	@Input() options: Array<InputDropdownOption>;
	// tslint:disable:no-null-keyword */
	@Input() hasDefaultSelectOption = true;
	@Input() sortOptions = false;
	@Input() showTooltip = false;
	// Want to use null to match how Angular sets values for empty form controls
	@Input() defaultSelectOption: InputDropdownOption = {
		display: UI_CONSTANTS.INPUT_DROPDOWN.DEFAULT_SELECT_DISPLAY,
		value: null
	};
	@Input() addDefaultOption = true;
	@Input() disableDefaultOption = false;

	ngOnInit(): void {
		super.ngOnInit();
		if (this.hasDefaultSelectOption) {
			this.control.setValue(this.defaultSelectOption.value);
		} else {
			this.control.setValue(this.getExactOptionReference(this.value));
		}

		if (this.sortOptions) {
			SortUtilityService.sort(this.options, false, 'display');
		}
	}

	onSubmitSuccess = (newValue): void => {
		this.value = this.getExactOptionReference(newValue);
		this.control.setValue(this.getExactOptionReference(newValue));
	};

	onReset = (): void => {
		this.control.reset(this.getExactOptionReference(this.value));
	};

	private getExactOptionReference(value): InputDropdownOption | undefined {
		if (typeof value !== 'object' || value === null) {
			return this.options?.find((e) => e.value === value)?.value;
		}

		const selectedOpt = this.options.find((e) => e.value?.id === value.id);

		if (selectedOpt) {
			return selectedOpt.value ? selectedOpt.value : selectedOpt;
		}

		return undefined;
	}
}
